module.exports = __webpack_public_path__ + "img/base2-sm.dc538f5c.jpg";